import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { confirmAlert } from 'react-confirm-alert';
import theme from '../../styles/theme.styles';
import LayoutWrapper from './LayoutWrapper';
import { DataContext } from '../../contexts/dataContext';

function Header({ userName, onLogout }) {
  const dataContext = useContext(DataContext);
  const { authSignOut } = dataContext;

  const handleSignOut = (e) => {
    confirmAlert({
      overlayClassName: 'overlay-confirm-modal',
      customUI: ({ onClose }) => (
        <CustomModalUI>
          <ModalTitle>Are you sure?</ModalTitle>
          <ModalSubTitle>I want to logout</ModalSubTitle>
          <ModalButtonsContainer>
            <StyledButton onClick={onClose}>No</StyledButton>
            <StyledButton
              onClick={() => { authSignOut(); onClose(); }}
            >
              Yes
            </StyledButton>
          </ModalButtonsContainer>
        </CustomModalUI>
      ),
    });
  };

  return (
    <SHeader>
      <LayoutWrapper>
        <Columns>
          <ColLogo>
            <svg
              width={121}
              height={39}
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M56.123 17.38l-.336-2.075H50.68L49.62 17.38H46.33l6.77-13.226h3.965l2.184 13.226h-3.125zm-3.998-4.905H55.3l-.622-5.006-2.553 5.006zM60.306 17.38l1.058-6.027 1.361-7.768h2.856l-1.394 7.92-1.042 5.892h-2.84v-.016zM65.245 17.38l1.058-6.027 1.361-7.768h2.856l-1.394 7.92-1.042 5.892h-2.839v-.016zM70.184 17.38l1.663-9.459h2.857l-1.664 9.46h-2.856zM74.754 6.6c-.386.334-.823.502-1.294.502-.487 0-.856-.168-1.125-.502-.27-.335-.37-.737-.286-1.206.084-.452.302-.854.689-1.188.386-.335.806-.52 1.277-.52.47 0 .84.168 1.125.503.286.335.387.736.32 1.205-.101.469-.32.87-.706 1.206zM83.674 7.938h2.84l-1.664 9.46h-2.839l.118-.637c-.723.603-1.663.904-2.84.904-1.461 0-2.502-.519-3.174-1.574-.656-1.055-.857-2.26-.588-3.633.235-1.306.84-2.41 1.797-3.348.958-.938 2.134-1.406 3.545-1.406 1.193 0 2.066.418 2.654 1.272l.151-1.038zm-4.99 6.412c.337.419.84.62 1.496.62.655 0 1.226-.201 1.73-.62.488-.418.807-.97.924-1.657v-.017c.135-.703.017-1.272-.336-1.691-.352-.418-.856-.62-1.512-.62-.655 0-1.226.201-1.713.62-.487.419-.79.971-.924 1.69-.118.687 0 1.257.336 1.675zM94.09 7.67c1.025 0 1.831.352 2.42 1.055.587.703.772 1.657.554 2.863l-1.025 5.81h-2.856l.958-5.392c.1-.586.016-1.004-.236-1.289-.252-.284-.638-.418-1.125-.418-.504 0-.94.15-1.327.452-.37.301-.622.77-.756 1.373l-.924 5.273h-2.856l1.663-9.459h2.856l-.151.87c.705-.753 1.646-1.138 2.805-1.138zM102.759 17.648c-1.512 0-2.671-.502-3.511-1.49-.84-.988-1.143-2.226-.907-3.683.218-1.39.856-2.528 1.915-3.449 1.058-.904 2.301-1.356 3.729-1.356.991 0 1.831.218 2.52.67.689.452 1.21 1.038 1.512 1.791l-2.604 1.356c-.285-.686-.856-1.021-1.696-1.021-.639 0-1.193.2-1.664.603-.487.402-.772.92-.89 1.557-.118.636 0 1.172.336 1.59.336.419.823.636 1.445.636.806 0 1.461-.351 1.965-1.054l2.302 1.456c-.487.787-1.126 1.39-1.915 1.792a5.45 5.45 0 01-2.537.602zM113.88 7.67c1.412 0 2.52.486 3.344 1.44.823.954 1.108 2.143.84 3.55a5.97 5.97 0 01-.303 1.138h-6.787c.134.887.79 1.322 1.949 1.322.789 0 1.461-.25 1.999-.736l1.999 1.624c-1.092 1.105-2.486 1.64-4.166 1.64-1.613 0-2.823-.502-3.646-1.49s-1.125-2.226-.873-3.683c.218-1.373.857-2.511 1.932-3.432 1.041-.92 2.284-1.373 3.712-1.373zm-2.52 3.968h4.016c-.084-.971-.656-1.457-1.714-1.457-1.025 0-1.798.486-2.302 1.457zM56.123 34.574l-.336-2.076H50.68l-1.059 2.076H46.33l6.77-13.226h3.965l2.184 13.226h-3.125zm-3.998-4.905H55.3l-.622-5.006-2.553 5.006zM64.707 27.844l-.587 3.348c-.085.386.033.637.319.737.285.1.79.134 1.495.067l-.454 2.578c-1.697.184-2.89 0-3.561-.552-.672-.553-.89-1.507-.655-2.83l.588-3.348H60.34l.487-2.729h1.512l.319-1.791 3.007-.854-.47 2.645h1.965l-.487 2.73h-1.966zM74.25 24.864c1.025 0 1.83.352 2.419 1.055.588.703.773 1.657.554 2.863l-1.025 5.809h-2.855l.957-5.39c.1-.587.017-1.005-.235-1.29-.252-.285-.638-.419-1.126-.419-.52 0-.974.168-1.344.486-.386.318-.621.804-.739 1.456l-.907 5.157h-2.856l2.335-13.226h2.856l-.823 4.654c.689-.77 1.613-1.155 2.789-1.155zM78.114 34.574l1.058-6.027 1.36-7.768h2.857l-1.394 7.919-1.042 5.893h-2.84v-.017zM89.118 24.864c1.41 0 2.52.485 3.343 1.44.823.954 1.108 2.143.84 3.55a5.954 5.954 0 01-.303 1.137h-6.787c.135.888.79 1.323 1.949 1.323.79 0 1.462-.251 2-.736l1.998 1.623c-1.092 1.105-2.486 1.641-4.166 1.641-1.613 0-2.822-.502-3.646-1.49-.823-.988-1.125-2.226-.873-3.683.218-1.373.857-2.511 1.932-3.432 1.041-.921 2.301-1.373 3.713-1.373zm-2.504 3.968h4.015c-.084-.971-.655-1.457-1.713-1.457s-1.814.486-2.302 1.457zM98.61 27.844l-.589 3.348c-.084.385.034.636.32.737.285.1.79.134 1.495.067l-.454 2.578c-1.697.184-2.89 0-3.561-.552-.672-.553-.89-1.507-.656-2.83l.588-3.348h-1.511l.487-2.729h1.512l.319-1.791 3.007-.837-.47 2.645h1.965l-.487 2.712h-1.966zM106.875 24.864c1.411 0 2.52.485 3.343 1.44.823.954 1.109 2.143.84 3.55a5.968 5.968 0 01-.302 1.137h-6.788c.135.888.79 1.323 1.949 1.323.79 0 1.462-.251 1.999-.736l2 1.623c-1.092 1.105-2.487 1.641-4.167 1.641-1.613 0-2.822-.502-3.645-1.49-.824-.988-1.126-2.226-.874-3.683.219-1.373.857-2.511 1.932-3.432 1.042-.921 2.302-1.373 3.713-1.373zm-2.503 3.968h4.015c-.084-.971-.655-1.457-1.714-1.457-1.041 0-1.814.486-2.301 1.457zM115.258 34.842c-1.966 0-3.293-.77-3.998-2.327l2.553-1.29c.286.72.84 1.072 1.697 1.072.638 0 .991-.167 1.041-.485.034-.201-.1-.369-.42-.52a11.258 11.258 0 00-1.159-.4 9.97 9.97 0 01-1.344-.486c-.437-.201-.772-.536-1.041-.988-.252-.452-.319-1.038-.185-1.708.118-.636.386-1.189.823-1.624.437-.435.924-.753 1.462-.937a5.25 5.25 0 011.713-.285c.84 0 1.579.184 2.218.536a3.274 3.274 0 011.411 1.49l-2.554 1.272c-.235-.552-.638-.837-1.226-.837-.571 0-.89.201-.974.586-.051.251.084.452.386.586.302.134.689.268 1.142.368.454.1.908.251 1.344.436.437.184.79.502 1.042.97.252.453.319 1.055.185 1.775-.185.955-.639 1.674-1.378 2.127-.756.435-1.663.67-2.738.67z"
                fill="#fff"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.03 19.212c0 10.574 8.566 19.164 19.114 19.164s19.115-8.59 19.115-19.164C38.259 8.637 29.692.047 19.144.047 8.596.047.029 8.637.029 19.212zm16.805-14.66C9.77 5.67 4.342 11.822 4.342 19.212c0 1.86.344 3.642.972 5.285 3.354-2.342 6.054-5.25 8.027-8.686 1.963-3.42 3.136-7.192 3.494-11.259zM7.658 28.557c2.717 3.35 6.858 5.495 11.486 5.495 4.628 0 8.77-2.145 11.486-5.495-3.69-1.724-7.538-2.604-11.486-2.604-3.948 0-7.797.88-11.486 2.604zm25.312-4.05c.63-1.645.976-3.431.976-5.296 0-7.396-5.438-13.554-12.512-14.662.357 4.068 1.53 7.842 3.494 11.262 1.976 3.442 4.68 6.353 8.042 8.697zm-9.279-2.667a30.668 30.668 0 00-9.126.005 30.875 30.875 0 004.563-7.889 30.787 30.787 0 004.563 7.884z"
                fill="#fff"
              />
            </svg>
          </ColLogo>
          <ColUser>
            <svg width={22} height={23} fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.795.917C4.905.917.128 5.692.128 11.583S4.904 22.25 10.795 22.25c5.892 0 10.667-4.776 10.667-10.667S16.687.917 10.795.917zm0 3.189a3.528 3.528 0 110 7.057 3.528 3.528 0 010-7.057zm-.002 15.355a7.829 7.829 0 01-5.098-1.88 1.504 1.504 0 01-.528-1.143c0-1.976 1.6-3.557 3.576-3.557h4.105a3.553 3.553 0 013.57 3.557 1.5 1.5 0 01-.527 1.143 7.826 7.826 0 01-5.098 1.88z"
                fill="#fff"
              />
            </svg>
            { userName }
            <LogoutButton onClick={handleSignOut}>
              <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7 19H3a2 2 0 01-2-2V3a2 2 0 012-2h4M14 15l5-5-5-5M19 10H7"
                  stroke="#fff"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </LogoutButton>
          </ColUser>
        </Columns>

      </LayoutWrapper>
    </SHeader>
  );
}
Header.propTypes = {
  userName: PropTypes.string,
  onLogout: PropTypes.func,
};

Header.defaultProps = {
  userName: 'Loading...',
  onLogout: () => {},
};

export default Header;

const SHeader = styled.header`
    position: fixed;
    top: 0;right: 0; left: 0;
`;
// const Spacer = styled.div`
//     height: ${theme.sizes.header.height.tabletPortrait}px;
//     @media ${theme.mq.desktop} {
//         height: ${theme.sizes.header.height.desktop}px;
//     }
// `
const Columns = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
`;
const ColLogo = styled.div`
    width: ${theme.sizes.columns.col1.tabletPortrait}px;
    padding: ${theme.sizes.header.paddingTop.tabletPortrait}px 0 8px 8px;
    @media ${theme.mq.desktop} { 
        width: ${theme.sizes.columns.col1.desktop}px;
        padding: ${theme.sizes.header.paddingTop.desktop}px 0 8px 8px;
    }
`;
const ColUser = styled.div`
    width: ${theme.sizes.columns.col2.tabletPortrait}px;
    padding: ${theme.sizes.header.paddingTop.tabletPortrait}px 0 8px 0;
    text-align: right;
    @media ${theme.mq.desktop} { 
        width: ${theme.sizes.columns.col2.desktop}px;
        padding: ${theme.sizes.header.paddingTop.desktop}px 0 8px 0;
    }
    & > svg{
        vertical-align: middle;
        margin-right: 8px;
    }
    z-index: 10;
`;

const LogoutButton = styled.span`
    display: inline-block;
    vertical-align: middle;
    margin-left: 24px;
    opacity: 0.6;
    cursor: pointer;
    &:hover{
        opacity: 1;
    }
`;
const CustomModalUI = styled.div`
  text-align: center;
  width: 500px;
  padding: 40px;
  background: ${theme.colors.royalBlue};
  box-shadow: 0 20px 75px rgba(0, 0, 0, 0.23);
  color: #fff;
`;
const ModalTitle = styled.h1`
  margin: 10px 0 23px 0;
  font-size: 32px;
  font-weight: 700;
  line-height: 41px;
  letter-spacing: 0.374px;
`;
const ModalSubTitle = styled.p`
  margin: 10px 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: 0.374px;
`;
const StyledButton = styled.div`
  width: 160px;
  padding: 10px;
  border: 1px solid #fff;
  margin: 10px;
  cursor: pointer;
  background: none;
  color: #fff;
  font-size: 14px;
  &:hover{
    background-color: ${theme.colors.transparentWhite2};
    border-color: ${theme.colors.white};
  }
`;
const ModalButtonsContainer = styled.div`
    display: flex;
    justify-content: space-around;
    width: 100%;
    height: 55px;
    margin-top: 20px;
`;
